// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f2e2197e","488":"2ad7946f","667":"c4f3a15b","977":"9566b12d"}[chunkId] + ".chunk.js";
};